module.exports = __webpack_public_path__ + "static/media/greenRightIcon.0516b4a7.svg";